import { render } from "./Administrators.vue?vue&type=template&id=3f9264da&scoped=true"
import script from "./Administrators.vue?vue&type=script&lang=js"
export * from "./Administrators.vue?vue&type=script&lang=js"

import "./Administrators.vue?vue&type=style&index=0&id=3f9264da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9264da"]])

export default __exports__